import axios from "axios";
import { sisi2_api_url, sisi_api_url } from "..";
import { DateTime } from "luxon";

export const getUserPoints = ({
  guest_crm_uid,
  currency = "TRV",
  product_type = null,
  product_uid = null,
}) => {
  return axios.get(`${sisi2_api_url}/paymentengine/guest-crm-user-entry/`, {
    params: {
      guest_crm_uid,
      page_size: 1000,
      currency,
      product_type,
      product_uid,
    },
  });
};

export const creditUserPoints = ({
  source_entity,
  description,
  currency,
  amount,
  guest_crm_uid,
}) => {
  return axios.post(`${sisi2_api_url}/paymentengine/guest-crm-user-entry/`, {
    source_entity,
    description,
    currency,
    amount,
    external_created: DateTime.now().toISO({ includeOffset: false }),
    entry_type: "CR",
    guest_crm_uid,
  });
};

export const getAvailableExternalPoints = ({ ext_user_id }) => {
  return axios.get(
    `${sisi_api_url}/guest-crm/available-points/${ext_user_id}/`
  );
};
